const passwordErrorsList = [
  "Password is required.",
  "Password must have at least 8 characters.",
  "Must have a number."
];

export default passwordErrorsList;
